import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkspaceService } from 'src/app/core/services/workspace.service';
import * as _ from 'lodash';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { UtilityService } from 'src/app/core/services/utility.service';

export interface Email {
  name: string;
  invalid: Boolean
}
@Component({
  selector: 'vcp-invite-popup',
  templateUrl: './invite-popup.component.html',
  styleUrls: ['./invite-popup.component.scss'],
})
export class InvitePopupComponent implements OnInit {
  memberList = [];
  sendBtnDisable = true;
  visible = true;
  btnLoader = false;
  linkLoader = false;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  emails: Email[] = [];
  constructor(
    public dialogRef: MatDialogRef<InvitePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly workspaceService: WorkspaceService,
    private readonly us: UtilityService
  ) { }

  ngOnInit(): void { }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      if (this.validateEmail(value)) {
        this.emails.push({ name: value.trim(), invalid: false });
      } else {
        this.emails.push({ name: value.trim(), invalid: true });
      }
    }

    if (input) {
      input.value = '';
    }
    this.btnDisable();
  }

  btnDisable() {
    if (this.emails.length > 0) {
      let email = this.emails.find(ele => ele.invalid == true);
      this.sendBtnDisable = email ? true : false
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  remove(email: Email): void {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
    this.btnDisable();
  }

  getShareLink() {
    if (this.linkLoader) return;
    let data = {
      userId: this.us.getUserId(),
      username: this.us.getUserName(),
      workspaceId: this.data.workspace.workspaceId
    };
    const query = this.us.getObjToQueryParam(data);
    this.linkLoader = true
    this.workspaceService
      .getSharedLink(query,)
      .subscribe((res) => {
        this.linkLoader = false;
        if (res && res['code'] === 'success') {
          this.copyLink(res['data'].sharableLink);
        }
      });
  }

  copyLink(value) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.us.openSnackBar('Link copied');
  }

  saveData() {
    if (this.btnLoader) return;
    let data = {
      userId: this.us.getUserId(),
      username: this.us.getUserName(),
      emails: this.emails.map((ele) => ele.name),
    };
    this.btnLoader = true
    this.workspaceService
      .shareRequest(data, this.data.workspace.workspaceId)
      .subscribe((res) => {
        this.btnLoader = false;
        if (res && res['code'] === 'success') {
          this.us.openSnackBar(res['message']);
          this.onNoClick();
        }
      });
  }




  onNoClick(): void {
    this.dialogRef.close();
  }
}
